import React from 'react';
import Link from 'next/link';
import { withRouter } from 'next/router';
import { NAME_PROJECT, USER_ACCESS_TOKEN_NAME } from '../../../../settings/global';
import { setCookie } from "../../../../helpers/common";
import Input from "../../../../components/Input";
import Button from "../../../../components/ripple/Button";
import { createFetch } from "../../../../helpers/fetch/FetchRequest";
import { getUserData, redirectToLastState } from "../../../../helpers/data/get/user";
import { dispatchNotification } from "../../../../layouts/app/components/notificationSystem/notifications";
import styles from './SignForms.module.scss';
import { signForm } from "./helpers";
import { NAV_PASSWORD_RECOVER, NAV_SIGN_UP } from "../../../../settings/navigation";
import { API_LOGIN_NODE } from "../../../../settings/endpoints/user";

class SignInPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            loading: false,
            url_access_confirm: '',
            email: '',
            password: '',
            errors: {}
        };
    }

    _onSubmit = e => {

        e.preventDefault();
        this.props.setLoading(true);

        let data = {
            email: this.state.email,
            password: this.state.password,
        };
        const formData = new FormData(e.currentTarget);

        // console.log(e.currentTarget)

        createFetch({
            method: 'POST',
            URL: API_LOGIN_NODE,
            body: data,
            // body: formData,
            onSuccess: data => {
                setCookie(USER_ACCESS_TOKEN_NAME, data.access_token);

                dispatchNotification({
                    requestTitle: 'Log in',
                    message: "You were successfully logged in.",
                    type: 'success',
                });

                getUserData();
                redirectToLastState();
            },
            onError: error => {

                this.props.setLoading(false);

                let res = error.responseBody;

                switch (error.error.status) {
                    case 401:
                        this.setState({
                            errors: {
                                email: true,
                                password: true
                            }
                        })
                        dispatchNotification({
                            message: res._error.message,
                            type: "error",
                            errorFetch: error,
                            requestTitle: 'Sign in'
                        });
                        break;
                    case 500:
                        dispatchNotification({
                            message: 'Logging in is currently unavailable. Sorry for inconvenience, our engineers are working on it.',
                            type: "error",
                            errorFetch: error,
                            requestTitle: 'Sign in'
                        });
                        break;
                    case 502:
                        dispatchNotification({
                            message: 'Logging in is currently unavailable. Sorry for inconvenience, our engineers are working on it.',
                            type: "error",
                            errorFetch: error,
                            requestTitle: 'Sign in'
                        });
                        break;
                    case 409:
                        dispatchNotification({
                            message: res._error.message,
                            type: "error",
                            errorFetch: error,
                            requestTitle: 'Sign in'
                        });
                        break;
                    default:
                        dispatchNotification({
                            message: 'An error occurred',
                            type: "error",
                            errorFetch: error,
                            requestTitle: 'Sign in'
                        });
                }
            }
        })
    };

    _onChange = e => {

        let {name, value} = e.target;

        this.setState({
            [name]: value,
            errors: {},
        });
    };

    render() {
        return (
            <form
                className={styles['sign-form']}
                method="post"
                action="#"
                onSubmit={this._onSubmit}
                onChange={this._onChange}
            >
                <Input
                    placeholder='Email'
                    type="email"
                    name='email'
                    iconLeft='fas fa-at'
                    onChange={this._onChange}
                    value={this.state.email}
                    isValid={!!this.state.errors.email ? false : undefined}
                    ariaLabel="Email"
                    visualVariables={signForm.visuals}
                    disabled={this.props.loading}
                    required
                />
                <Input
                    type='password'
                    placeholder='Password'
                    ariaLabel="Password"
                    name='password'
                    iconLeft='fas fa-key'
                    onChange={this._onChange}
                    value={this.state.password}
                    isValid={!!this.state.errors.password ? false : undefined}
                    visualVariables={signForm.visuals}
                    disabled={this.props.loading}
                    required
                />
                <Button
                    title='Sign In'
                    className={styles['sign-form__button']}
                    disabled={this.props.loading}
                    role='info'
                    visuals={{
                        colorBasic: ['var(--colorAccentLight)'],
                        height: '5rem',
                        // borderRadius: '1rem',
                        borderRadius: 'var(--borderRadiusContainerInnerEdge)',
                    }}
                    type="submit"
                    iconRight='fas fa-sign-in-alt'
                />
                <div className={styles['sign-form__links']}>
                    <p>Don't have a {NAME_PROJECT} account? <Link href={NAV_SIGN_UP}>Create one</Link></p>
                    <p>Forgot your
                        password? <Link href={NAV_PASSWORD_RECOVER + '?email=' + this.state.email}>
                            Recover it
                    </Link>
                    </p>
                </div>
            </form>
        );
    }
}

export default withRouter(SignInPage)

SignInPage.propTypes = {
    // history: PropTypes.object.isRequired,
    // location: PropTypes.object.isRequired,
};